import { useState } from 'react';

// Vista de detalle con pestañas y acciones arriba a la derecha (patrón g).
// pestanas: [{ id, etiqueta, render:()=>JSX }]
// acciones: [{ etiqueta, onClick, principal? }]
export default function VistaDetalle({ titulo, subtitulo, acciones, pestanas, encabezado }) {
  const [activa, setActiva] = useState(pestanas[0]?.id);
  const pestana = pestanas.find((p) => p.id === activa) || pestanas[0];

  return (
    <div className="space-y-4">
      <div className="flex items-start justify-between gap-3 flex-wrap">
        <div>
          <h2 className="text-xl font-semibold text-gray-900">{titulo}</h2>
          {subtitulo && <p className="text-sm text-gray-500 mt-0.5">{subtitulo}</p>}
        </div>
        {/* U-02 fase a (corrección M1 a 320 px): las acciones y las pestañas
            pasan al renglón siguiente en vez de empujar la página de lado.
            Tres acciones o seis pestañas no caben en 288 px útiles; en
            escritorio caben en un renglón y no cambia nada. */}
        {acciones && (
          <div className="flex items-center gap-2 flex-wrap">
            {acciones.map((a, i) => (
              <button
                key={i}
                onClick={a.onClick}
                className={`text-sm font-semibold px-3 py-2 rounded-lg ${
                  a.principal
                    ? 'bg-[var(--color-marca)] hover:bg-[var(--color-marca-fuerte)] text-white'
                    : 'border border-gray-300 bg-white text-gray-700 hover:bg-gray-50'
                }`}
              >
                {a.etiqueta}
              </button>
            ))}
          </div>
        )}
      </div>

      {encabezado}

      <div className="border-b border-gray-200 flex flex-wrap gap-1">
        {pestanas.map((p) => (
          <button
            key={p.id}
            type="button"
            onClick={() => setActiva(p.id)}
            aria-current={pestana.id === p.id ? 'page' : undefined}
            className={`px-3 py-2 text-sm font-semibold border-b-2 -mb-px ${
              pestana.id === p.id
                ? 'border-[var(--color-marca)] text-[var(--color-marca)]'
                : 'border-transparent text-gray-500 hover:text-gray-800'
            }`}
          >
            {p.etiqueta}
          </button>
        ))}
      </div>

      <div>{pestana?.render()}</div>
    </div>
  );
}
